export default "__VITE_ASSET__22d3wWrM__"